import { Box, Checkbox, Dialog, DialogActions, DialogContent, FormControlLabel, Grid, Tooltip } from "@mui/material";
import { FC, useCallback, useEffect, useMemo, useState } from "react";
import { FlatButton } from "src/framework/components/buttons/FlatButton";
import { Projeto } from "../../types";
import { InputText } from "src/framework/components/forms/inputs/InputText";
import { InputDecimal3 } from "src/framework/components/forms/inputs/InputDecimal3";
import { Formater, TypeRecords } from "src/framework/commons/Formater";
import React from "react";
import api, { apiNoLoading, IDataRequest, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { ErrorValidate } from "src/components/pagamento/types";
import { MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR, MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA, MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO } from "src/App";
import adminStore from "src/store/AdminStore";
import { ProjetosProvider } from "src/providers/ProjetosProvider";
import { validacaoValorServicoMinimo } from "../../utils/validarValorServicoMinimo";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import theme from "src/theme/light";
import { verificaPendenciaTrocaComponente } from "../../utils/verificaPendenciaTrocaComponente";
import { showPendenciaTrocaComponenteAlert } from "../../utils/showPendenciaTrocaComponenteAlert";
import { notifierStore } from "src/framework/store/NotifierStore";

const projetosProvider = new ProjetosProvider()

interface ModalAlterarServicoParms {
    open: boolean;
    setOpenModal: Function;
    projeto?: Projeto;
    onSuccess: () => void;
}

interface ErrorState {
    valorMargem: ErrorValidate
}

const INITIAL_ERROR_STATE: ErrorState = {
    valorMargem: {
        hasError: false,
        hintText: ""
    },
}

export const CODIGO_SERVICO = [
    {
        text: "14.01",
        value: process.env.REACT_APP_CODIGO_SERVICO_14_01 || "9000005",
    },
    {
        text: "14.06",
        value: process.env.REACT_APP_CODIGO_SERVICO_14_06 || "9000006",
    }
];

const ModalAlterarServico: FC<ModalAlterarServicoParms> = (modalAlterarServicoParms) => {
    const permissoes = PermissionUtil.getPermissions();
    const [removerServico, setRemoverServico] = useState(false)
    const [valorMinimoServico, setValorMinimoServico] = useState(0)
    const [projetoState, setProjetoState] = useState<Projeto>();
    const [disableBotaoSalvar, setDisableBotaoSalvar] = React.useState<boolean>(true);
    const [valorServicoOriginal, setValorServicoOriginal] = React.useState<number>(0);
    const [valorServicoPisCofinsOriginal, setValorServicoPisCofinsOriginal] = React.useState<number>(0);
    const [valorTotalProdutosOriginal, setValorTotalProdutosOriginal] = React.useState<number>(0);
    const [valorTotalProjetoOriginal, setValorTotalProjetoOriginal] = React.useState<number>(0);
    const [valorTotalMargemProdutosOriginal, setValorTotalMargemProdutosOriginal] = React.useState<number>(0);
    const [valorTotalMargemProdutosAlterada, setValorTotalMargemProdutosAlterada] = React.useState<number>();
    const [valorServicoAlterar, setValorServicoAlterar] = React.useState<number>(0);
    const [valorServicoPisCofinsAlterar, setValorPisCofinsServicoAlterar] = React.useState<number>(0);
    const [valorTotalProjetoAlterado, setValorTotalProjetoAlterado] = React.useState<number>(0);
    const [fator, setFator] = useState(0);
    const [justificativaValorServico, setJustificativaValorServico] = useState('')

    const [errorState, setErrorState] = useState<ErrorState>(INITIAL_ERROR_STATE);

    const valorMinimoNaoPreenchido = useMemo(()=>{
        const status = !validacaoValorServicoMinimo(valorServicoAlterar, valorMinimoServico, permissoes);        

        return {
            status,
            tooltipMessage: status ? "Para confirmar é necessário inserir o valor mínimo de serviço" : ""
        }
    }, [valorServicoAlterar, valorMinimoServico])

    
    const exibirCampoJustificativa = useMemo(() => {
        if (!PermissionUtil.can(PermissionUtil.PERMISSION_PROJETOS_EDITAR_ESPECIAL_SERVICO, permissoes)) return false;
        if (Number(valorMinimoServico || 0) === 0) return false;
        if (Number(valorServicoAlterar || 0) === 0) return false;
        return Number(valorServicoAlterar) < Number(valorMinimoServico) 
    }, [permissoes, valorMinimoServico, valorServicoAlterar])

    const justificativaNaoPreenchida = useMemo(()=>{
        let status = false;

        if (exibirCampoJustificativa && !justificativaValorServico) {
            status = true;
        }

        return {
            status,
            tooltipMessage: status ? "Para confirmar é necessário inserir a justificativa do valor de serviço" : ""
        }
    }, [exibirCampoJustificativa, justificativaValorServico])

    const handleClose = () => {
        modalAlterarServicoParms.setOpenModal(false);
    };
    const handleSave = async () => {
        const dataProjeto: Projeto | any = {...projetoState};
        if (projetoState?.id) {
            await adminStore.getProjetoTrocasPendentes(projetoState?.id).then((resp) => {
                if (resp && resp?.componentes) dataProjeto.componentes = resp?.componentes;
                if (resp && resp?.componentes_modificados) dataProjeto.componentes_modificados = resp?.componentes_modificados;
            });
        }

        if (verificaPendenciaTrocaComponente(dataProjeto)) {
            showPendenciaTrocaComponenteAlert();
            return;
        }

        doSave();
    };
    //const setNovoValorServico = (novoValorServicoStr:string, novoValorMargemStr: string) => {
    const setNovoValorServico = (novoValorServico: number, novoValorMargem: number) => {
        //const novoValorServico = Number(novoValorServicoStr.replace('.','').replace(',','.'));
        //const novoValorMargem = Number(novoValorMargemStr.replace('.','').replace(',','.'));
        setErrorState(INITIAL_ERROR_STATE);
        if ((valorServicoOriginal !== novoValorServico) || (valorTotalMargemProdutosOriginal !== novoValorMargem)) {
            setDisableBotaoSalvar(false);

            if (!validadeMargem(novoValorServico, novoValorMargem)) {
                return;
            }

            //serviço + margem
            const servicoEMargemComPisCofins = (Number(novoValorServico) + Number(novoValorMargem)) / fator;
            const servicoTotalPisCofins = servicoEMargemComPisCofins - Number(novoValorServico);
            if (projetoState?.valor) {
                setValorServicoAlterar(Number(novoValorServico));
                setValorPisCofinsServicoAlterar(servicoTotalPisCofins);
                setValorTotalProjetoAlterado(Number(novoValorServico) + servicoTotalPisCofins + valorTotalProdutosOriginal);
                setValorTotalMargemProdutosAlterada(Number(novoValorMargem) || 0);
            }
        } else {
            setValorServicoAlterar(valorServicoOriginal);
            setValorServicoPisCofinsOriginal(valorServicoPisCofinsOriginal);
            setValorTotalProjetoAlterado(valorTotalProjetoOriginal);
            setValorTotalMargemProdutosAlterada(valorTotalMargemProdutosOriginal);
            setDisableBotaoSalvar(true);
        }
    }

    useEffect(() => {
        if (modalAlterarServicoParms.open && modalAlterarServicoParms?.projeto) {
            const projeto = modalAlterarServicoParms.projeto;
            setProjetoState(projeto);
            const valorServico = projeto?.valor_servico ? projeto?.valor_servico : 0;
            const valorServicoPisCofins = projeto?.valor_servico_pis_cofins ? projeto?.valor_servico_pis_cofins : 0;
            const valorProdutosOriginal = projeto?.valor ? projeto?.valor : 0;
            const valorMargemProdutos = 0;
            const valorTotalProjeto = projeto?.valor_projeto ? projeto?.valor_projeto : 0;
            setValorServicoOriginal(valorServico);
            setValorServicoPisCofinsOriginal(valorServicoPisCofins);
            setValorTotalMargemProdutosOriginal(valorMargemProdutos);
            setValorTotalMargemProdutosAlterada(valorMargemProdutos);
            setValorTotalProdutosOriginal(valorProdutosOriginal);
            setValorTotalProjetoOriginal(valorTotalProjeto);
            setValorTotalProjetoAlterado(valorTotalProjeto);
            setValorServicoAlterar(valorServico);
            setValorPisCofinsServicoAlterar(valorServicoPisCofins);
            setJustificativaValorServico(projeto?.justificativa_valor_servico || "");
        }
    }, [modalAlterarServicoParms.open]);

    const validForm = useCallback(() => {
        const messages = []

        if (exibirCampoJustificativa && !justificativaValorServico) {
            messages.push('Campo "Justificativa" é obrigatório!')
        }

        if (messages.length) {
            notifierStore.setNotifier({
                title: "Atenção!!!",
                content: messages,
                timeOut: 3500,
                onClose: () => notifierStore.setOpen(false)
            });
            notifierStore.setOpen(true);
            return false;
        }

        return true;
    }, [exibirCampoJustificativa, justificativaValorServico, valorServicoAlterar])

    const onFinishModal = ()=> {
        notifierStore.setOpen(false);
        modalAlterarServicoParms.onSuccess();
        modalAlterarServicoParms.setOpenModal(false);
    }

    const doSave = async (): Promise<void> => {
        if (!validForm()) return;

        let vigencia = true
        if (projetoState?.id) {
            await adminStore.buscarProjeto(projetoState.id, true).then(resp => {
                if (!resp?.length) vigencia = false;
            });
        }
        if (!vigencia) return;

        const novoValorPisConfis = (valorServicoAlterar !== valorServicoOriginal) ? (valorServicoAlterar + valorServicoPisCofinsAlterar) : valorServicoPisCofinsOriginal;

        const data = {
            "valor": valorTotalProdutosOriginal,
            "servico": (!valorServicoAlterar || valorServicoAlterar === 0) ? null : "revenda",
            "valor_servico": valorServicoAlterar,
            "valor_servico_pis_cofins": novoValorPisConfis,
            "codigo_venda": projetoState?.codigo_venda,
            "valor_margem_produtos": 0,
            "atualizar_proposta": true,
            "alterar_servico": true,
            "justificativa_valor_servico": exibirCampoJustificativa && justificativaValorServico ? justificativaValorServico.trim() : null,
        };
        const request: IDataRequest = {
            url: `/projetos/${projetoState?.id}`,
            data: data
        }
        const response: IDataResponse = await api.put(request);
        if (response.statusCode === STATUS_CODE.OK) {
            if (projetoState?.valor) {
                projetoState.valor_servico = valorServicoAlterar;
                projetoState.valor_servico_pis_cofins = novoValorPisConfis;
                projetoState.valor_projeto = valorTotalProjetoAlterado;
                projetoState.valor_margem_produtos = valorTotalMargemProdutosAlterada || 0;
            }
            notifierStore.setNotifier({
                title: "Aviso!!!",
                content: ["Valor de serviço atualizado com sucesso!"],
                timeOut: 3500,
                onClose: onFinishModal,
                onFinishTimeout: onFinishModal,
            });
            notifierStore.setOpen(true);

        } else {
            const message: string[] = [];
            if (response?.message) {
                if (Array.isArray(response?.message)) {
                    response?.message.forEach((m:string) => message.push(m));
                } else if (typeof response?.message === "string") {
                    message.push(response?.message);
                }
            }
            const mensagemVigencia = message?.includes(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO) || message?.some(msg => msg?.includes(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO));
            notifierStore.setNotifier({
                title: "Aviso!!!",
                content: mensagemVigencia ? MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO : ["Não foi possível realizar a atualização de valor de serviço."],
                timeOut: 3500,
                onClose: () => {
                    notifierStore.setOpen(false);
                    if (mensagemVigencia) window.location.href = `${window.location.origin}/projetos/menu-projetos`;
                }
            });
            notifierStore.setOpen(true);
        }
    }

    const validadeMargem = (valorServico: number, valorMargem: number) => {
        const errors = { ...errorState }
        if (valorMargem > valorServico) {
            errors.valorMargem = { hasError: true, hintText: "O valor da margem não pode ser maior do que o valor da instalação." };
            setDisableBotaoSalvar(true);

            setErrorState({ ...errors })

            return false;
        }

        return true;
    }

    useEffect(() => {
        const loadFator = async () => {
            const request: IDataRequest = {
                url: `/projetos/fator`
            }
            const response = await apiNoLoading.get(request)
            if (response.statusCode === STATUS_CODE.OK) {
                setFator(response?.data?.fator)
            } else {
                const message: string[] = Array.isArray(response?.message) ? response?.message : [response?.message];
                const mensagemVigencia = message?.some(m => m?.includes(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO));
                const mensagemSegmentoRevenda = message?.some(m => m?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA));
                const mensagemSegmentoDistribuidor = message?.some(m => m?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR));
                notifierStore.setNotifier({
                    title: "Atenção!!!",
                    content: (mensagemVigencia || mensagemSegmentoRevenda || mensagemSegmentoDistribuidor) ? message : ["Não é possível calcular o valor de serviço. Por favor, contate o seu suporte Intelbras"],
                    timeOut: 3500,
                    onClose: () => notifierStore.setOpen(false)
                });
                notifierStore.setOpen(true);
            }
        }
        loadFator()
    }, [modalAlterarServicoParms.open])

    useEffect(() => {
        if ((projetoState?.potencia || 0) > 0) {
            const potenciaProjeto = Number((projetoState?.potencia || 0).toFixed(2))

            projetosProvider.calcularValorMinimoServico(potenciaProjeto).then((response) => {
                setValorMinimoServico(response.data?.valor_minimo_servico || 0)
            })
        }
    },[projetoState])

    useEffect(()=>{
        if (valorMinimoServico > 0 && (projetoState?.valor_servico || 0) > 0 && !validacaoValorServicoMinimo(projetoState?.valor_servico || 0, valorMinimoServico, permissoes)) {
            notifierStore.setNotifier({
                title: 'Atenção!',
                content: [
                    'O valor do serviço não atende às exigências vigentes.',
                    'Por favor, atualize conforme as instruções fornecidas abaixo do campo "Novo valor de serviço”.'
                ],
                timeOut: 4000,
                onClose: () => notifierStore.setOpen(false),
                });
            notifierStore.setOpen(true);
        }
    },[projetoState, valorMinimoServico])

    const valorMinimoHelperText = useMemo(()=>{
        if (valorMinimoServico <= 0) return ""
        if (validacaoValorServicoMinimo(valorServicoAlterar, valorMinimoServico, permissoes)) return ""
        return <span style={{ color: theme.palette.error.main }}>Para inserir o valor de serviço na plataforma o valor mínimo tem que ser de {Formater.toString(Number(valorMinimoServico), TypeRecords.CURRENCY)}.</span>
    }, [valorMinimoServico, valorServicoAlterar])

    return (
        <Dialog
            open={modalAlterarServicoParms.open}
            onClose={handleClose}
            maxWidth='md'
        >
            <DialogContent>
                <Grid container spacing={1}>
                    <Grid container size={12}>
                        <Grid size={12}>
                            <Box component={"h2"}>Alterar Serviço - <span style={{ fontSize: 15, fontWeight: 'normal' }}>{projetoState?.codigo_venda}</span></Box>
                        </Grid>
                    </Grid>
                    <Grid container size={12}>
                        <Grid container size={12}>
                            <InputText
                                label={"Serviço Aplicado"}
                                fullWidth={true}
                                value={Formater.toString(Number(valorServicoOriginal), TypeRecords.CURRENCY)}
                                disabled
                            />
                        </Grid>
                        <Grid container size={12}>
                            <InputDecimal3
                                label={"Novo valor de serviço"}
                                fullWidth={true}
                                disabled={removerServico || !projetoState?.revenda?.segmentos_servico?.includes(projetoState?.segmento?.includes("on") ? "on" : "off")}
                                value={valorServicoAlterar}
                                prefix={<>R$&nbsp;</>}
                                helperText={valorMinimoHelperText}
                                error={!!valorMinimoHelperText}                      
                                decimal={2}
                                margin="normal"
                                onChange={(el: any) => {
                                    setValorServicoAlterar(el.target.value);
                                    setNovoValorServico(Number(el.target.value), Number(valorTotalMargemProdutosAlterada));
                                }}
                                onKeyDown={(el: React.KeyboardEvent<HTMLInputElement>) => {
                                    if (el.key === "-") {
                                        el.preventDefault();
                                    }
                                }}
                                InputProps={{
                                    onInput: (event: any) => {
                                      const value = event.target.value
                                      const cleanedText = value.replace(/-/g, '');
                                      event.target.value = cleanedText
                                    }
                                }}
                            />
                        </Grid>
                        <Grid container size={12}>
                            <InputText
                                label={"Valor final da proposta"}
                                fullWidth={true}
                                value={Formater.toString(Number(valorTotalProjetoAlterado), TypeRecords.CURRENCY)}
                                disabled
                            />
                        </Grid>
                        {exibirCampoJustificativa && (
                            <Grid container size={12}>
                                <InputText
                                    fullWidth
                                    value={justificativaValorServico || ""}
                                    onChange={(e: any) => {
                                        // Remove caracteres especiais
                                        const caracterEspecialRegex = /[^a-zA-Z0-9\s]/g
                                        e.target.value = e.target.value.replace(caracterEspecialRegex, '')

                                        // Verifica se o valor é somente espaços em branco
                                        const somenteEspacos = !/\S/.test(e.target.value)
                                        if (somenteEspacos) e.target.value = ""

                                        // Atualiza o estado do formulário
                                        setJustificativaValorServico(e.target.value || '')
                                        setDisableBotaoSalvar(false);
                                    }}
                                    label="Justificativa"
                                    maxLength={400}
                                    placeholder="Informe o motivo de estar adicionando um valor menor que o valor mínimo"
                                />
                            </Grid>
                        )}

                        <Grid container size={12}>
                            <FormControlLabel
                                label={(
                                    <Box marginTop={2} display={"flex"} flexDirection={"column"}>
                                        <span>Remover valor de serviço do projeto</span>
                                        <span style={{ fontSize: 12, color: theme.palette.error.main }}>Ao selecionar essa opção, o novo valor de serviço será R$ 0,00.</span>
                                    </Box>
                                )}
                                control={
                                    <Checkbox
                                        checked={removerServico}
                                        onChange={(_, checked) => {
                                            setNovoValorServico(0, Number(valorTotalMargemProdutosAlterada));
                                            setRemoverServico(checked)
                                        }}
                                    />
                                }
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <FlatButton
                    color="inherit"
                    variant="contained"
                    disableElevation
                    text="Cancelar"
                    onClick={handleClose}
                />
                <Tooltip title={valorMinimoNaoPreenchido.tooltipMessage || ""}>
                    <span>
                        <FlatButton
                            color="primary"
                            variant="contained"
                            disableElevation
                            disabled={disableBotaoSalvar || !fator || valorMinimoNaoPreenchido.status || justificativaNaoPreenchida.status}
                            text="Confirmar"
                            onClick={handleSave}
                        />
                    </span>
                </Tooltip>
            </DialogActions>
        </Dialog>
    );
}

export { ModalAlterarServico }
